<template>
  <div>
    <el-dialog :visible.sync="visible" custom-class="whaty-dialog-form" @close="handleCancel">
      <div slot="title" class="popup-head">
        <span class="popup-tit">切换角色</span>
      </div>
      <div v-loading="loading">
        <div class="popup-body">
          <div class="popup-content popup-content-complex" style="overflow-y:auto; overflow-x:auto;">
            <div class="clearfix popup-content-in">
              <div>
                <el-form   :model="form" >
                   <el-form-item :label="'当前的角色是：'+current.pePriRole.name">
                   </el-form-item>
                  </el-form>
                <el-form  :inline="true"  :model="form" >
                              <el-form-item  label="选择角色：" label-width="110px" >
                                    <el-select  placeholder="请选择角色" v-model="itemId" style="width:96%;float:right">
                                    <el-option  v-for="c in items"  :label="c.pePriRole.name" :value="c.pePriRole.id" :key="c.pePriRole.id"></el-option>
                                    </el-select>
                                </el-form-item>  
                    </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="popup-foot">
        <a href="javascript:" class="btn btn-solid" @click="change">确认切换</a>
        <a href="javascript:" class="btn btn-hollow" @click="handleCancel">取消</a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import util from '../../../../libs/util'
import qs from 'qs'
  export default {
    name: 'my-switch',
    data() {
      return {
        activeName: '',
        themePath: '',
        visible: false,
        loading: false,
        form:{},
        items:[],
        itemId:'',
        current:{}
      }
    },
    created() {
       this.loadMyRole();
    },
    methods: {
      show () {
          this.visible = true
      },
      hide () {
        this.visible = false
      },close(){

      },handleCancel(){
        this.visible = false;

      },change(){
           if(this.itemId.length ==0){
                this.$notify.error({title: '提示', message: '请选择角色'});
                return;
           }
           var  url  = "/jpcp/prirole/modifyMyRole/"+this.itemId;
           this.classrooms =[];
           util.ajax.post(url).then((res) => {
                            var  meta = res.data.meta;
                            var data = res.data.data;
                            if(meta.errCode == 0){
                                this.$notify.success({title: '成功', message: '操作成功'});
                                this.visible = false;
                                localStorage.removeItem(util.user() + "_currentTab");
                                localStorage.removeItem(util.user() + "_topTabList");
                                localStorage.removeItem(util.user() + "_currentPageId");
                                util.ajax.get("/logout").then((res) =>{
                                     const result = util.ajax.post('/oauth/token', qs.stringify({
                                            username: util.user(),
                                            password: this.items[0].ssoUser.password,
                                            client_id:util.getClientIdByDomain(),
                                            grant_type:"password"
                                    })).then((res) => {
                                            util.token(res.data.access_token);
                                            setTimeout(function(){
                                                window.location.href ="/manage";
                                            },100);
                                    });
                               });
                            }else{
                                this.$notify.error({title: '失败', message: '操作失败'});
                            }
           }).catch((e) => {
               console.error(e)
         })
      },
      loadMyRole(){
           var  url  = "/jpcp/prirole/getMyRoleList";
           this.classrooms =[];
           util.ajax.post(url).then((res) => {
                  console.info(res.data);
                    if (res.data.meta.errCode == 0) {
                        var  meta = res.data.meta;
                        if(!res.data["data"]){
                          return ;
                        }
                        var data = res.data.data;
                        this.items= [];
                        for(var i=0;i<data.length;i++){
                          var temp = data[i];
                          if(temp.pePriRole.id ==temp.ssoUser.pePriRole.id){
                              this.current= temp;
                          }
                            this.items.push(temp);
                        }
                        this.$emit("loadsuccess",this.items);
                    }else{

                    }
           }).catch((e) => {
               console.error(e)
         })


        }

    }
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/jpcp/homepage/switchRole.vue